import { ADD_DETAILS_ROUTE } from '@/utils/constants'

export default [
  {
    // "Add details" screen shown right after an item is saved (share flow).
    // Fullscreen: the view is its own app shell with a fixed banner and footer.
    path: ADD_DETAILS_ROUTE,
    component: () => import('@/views/CollectionItems/ItemAddDetailsPage.vue'),
    meta: {
      requiresAuth: true,
      layout: 'fullscreen',
      transition: 't-fade',
      layoutTransition: 't-fade',
      noScrollPreservation: true,
      systemBar: {
        color: 'neutral0',
      },
    },
  },
]
